<template>
  <!-- Titre du sous-menu cliquable -->
  <a
      href="javascript:;"
      class="side-menu__item"
      :class="menuData?.selected ? 'active' : ''"
      @mouseover="HoverToggleInnerMenuFn && HoverToggleInnerMenuFn($event, menuData)"
      @click.prevent="onToggle"
  >
    <i v-if="menuData?.icon" :class="`${menuData?.icon} side-menu__icon`"></i>

    <span class="side-menu__label">
        {{ menuData.title }}
        <span v-if="menuData.badge" :class="`badge ${menuData?.badgeColor} ms-1`">{{ menuData.badge }}</span>
      </span>

    <i class="fe fe-chevron-right side-menu__angle"></i>
  </a>

  <!-- Enfants -->
  <ul
      class="slide-menu child1"
      :class="[
        menuData.active ? 'double-menu-active' : '',
        menuData?.dirchange ? 'force-left' : '',
      ]"
      :style="menuData.active ? 'display:block' : ''"
      v-show="menuData.active"
  >
    <li v-if="level <= 1" class="slide side-menu__label1">
      <a href="javascript:void(0)">{{ menuData.title }}</a>
    </li>

    <li
        v-for="(child, subIndex) in menuData.children"
        :key="child.key || subIndex"
        :class="[
          child.menuTitle ? 'slide__category' : '',
          child?.type === 'empty' ? 'slide' : '',
          child?.type === 'link' ? 'slide' : '',
          child?.type === 'sub' ? 'slide has-sub' : '',
          child?.active ? 'open' : '',
          child?.selected ? 'active' : '',
        ]"
    >
      <!-- Lien -->
      <template v-if="child?.type === 'link'">
        <NuxtLink
            :to="child.path"
            class="side-menu__item"
            :class="child?.selected ? 'active' : ''"
            @click="onSelect($event, child)"
        >
          {{ child.title }}
          <span v-if="child.badge" :class="`badge ${child.badgeColor} ms-1`">{{ child.badge }}</span>
        </NuxtLink>
      </template>

      <!-- Sous-menu -->
      <template v-else-if="child?.type === 'sub'">
        <RecursiveMenu
            :menuData="child"
            :toggleSubmenu="toggleSubmenu"
            :HoverToggleInnerMenuFn="HoverToggleInnerMenuFn"
            :setSubmenu="setSubmenu"
            :level="level + 1"
        />
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'RecursiveMenu',
  props: {
    menuData: { type: Object, required: true },
    toggleSubmenu: { type: Function, required: true },
    HoverToggleInnerMenuFn: { type: Function, required: true },
    setSubmenu: { type: Function, required: false },
    level: { type: Number, required: true },
  },
  methods: {
    onToggle(e) {
      this.toggleSubmenu && this.toggleSubmenu(e, this.menuData)
    },
    onSelect(e, child) {
      if (this.setSubmenu) this.setSubmenu(e, child)
    },
  },
}
</script>

<style scoped>
/* Securise l’affichage si un style global force display:none */
.slide-menu { display: block; }
</style>
  